import { render, staticRenderFns } from "./NvReadHistory.vue?vue&type=template&id=78058cc0&scoped=true&"
import script from "./NvReadHistory.vue?vue&type=script&lang=js&"
export * from "./NvReadHistory.vue?vue&type=script&lang=js&"
import style0 from "./NvReadHistory.vue?vue&type=style&index=0&id=78058cc0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.6@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78058cc0",
  null
  
)

export default component.exports